module.exports = __webpack_public_path__ + "img/arrow_right.36db97db.svg";